import { Component, OnInit, ViewChild, APP_ID, HostBinding } from '@angular/core';
import { MatDialog } from '@angular/material/dialog'
import { BtnCellRenderer } from 'src/app/core/grid/btn-cell-render.component';
import { DeleteCategoryDialogComponent } from 'src/app/core/dialogs/delete-category-dialog/delete-category-dialog.component';
import { AddCategoryDialogComponent } from 'src/app/core/dialogs/add-category-dialog/add-category-dialog.component';
import { AddOpDialogComponent } from 'src/app/core/dialogs/add-op-dialog/add-op-dialog.component';
import { NgxUiLoaderService } from 'ngx-ui-loader';
import { OperatingproceduresService } from 'src/app/service/operatingprocedures.service';
import { GridDataService } from 'src/app/service/grid-data.service';
import { BoardsService } from 'src/app/service/boards.service';
import { FilterChangedEvent, GridOptions } from 'ag-grid-community';
import { AgGridAngular } from 'ag-grid-angular';
export interface DialogData {
	performAction: string;
	placeholderdesc: string;
	placeholderurl: string;
	page;
}
export interface deleteOPData {
	id: Number;
	desc: String;
	page;
}
@Component({
	selector: 'app-operatingprocedure',
	templateUrl: './operatingprocedure.component.html',
	styleUrls: ['./operatingprocedure.component.scss'],
	standalone: false,  // NOSONAR
})
export class OperatingprocedureComponent implements OnInit {
	gridApi: any;
	gridColumnApi: any
	// gridOptions: GridOptions;
	setPagination = 'true';
	defaultColDef;
	paginationPageSize: number = 30;
	currentPageNo: any;
	currentPageBoolean: boolean = false;
	totalPage: any;
	currentPageForTotalPage: any;
	isLastPageFound: any;
	icons;
	rowCount;
	columnDefs;
	rowData;
	context: any;
	frameworkComponents;
	selectedRows: any = [];
	@ViewChild('agGrid', { static: true }) agGrid: AgGridAngular
	successMessage = '';
	errorMessage = '';
	gridOptions;
	dynamicHeight: number;
	totalRecords = 0; // Replace with your actual total records count
	sRecord = 1;
	eRecord = 1;
	cPage = 1;
	tPage = 0;
	rpPage: any = 30;
	endRecord = 0;
	pgDropDown = [
		{ value: 5, selected: false },
		{ value: 10, selected: false },
		{ value: 20, selected: false },
		{ value: 30, selected: true },
		{ value: 50, selected: false },
	]
	constructor(private readonly gridDataService: GridDataService,
		public dialog: MatDialog, private readonly ngxUiLoaderService: NgxUiLoaderService,
		private readonly OPService: OperatingproceduresService,
		private readonly boardService: BoardsService) {
		this.dynamicHeight = 0.665 * (window.innerHeight);
		this.context = {
			componentParent: this
		};
		this.gridOptions = this.gridDataService.getGridOptions();
		this.columnDefs = [
			{
				headerName: "DESCRIPTION", headerClass: "table_id", field: "description", cellClass: "cell_desc",
				minWidth: 600, maxWidth: 600, sortable: true, unSortIcon: true,
				suppressFloatingFilterButton: true, suppressHeaderMenuButton: true, suppressMenu: true,
				floatingFilterComponentParams: { suppressFilterButton: true },
				filter: 'agTextColumnFilter',
				autoHeight: true,
				cellRenderer: (params:any) => {
					let descvalue = params.value.toString();
					let urlvalue = this.rowData.find((x:any) => x.description === params.value.toString()).url;
					return `<a href="${urlvalue}" target="_blank" style="color:#1e93c2"> ${descvalue} </a>`;
				}
			},
			{
				headerName: "ACTIONS", headerClass: "table_action", field: "OP_action", cellClass: "cell_action",
				minWidth: 120,
				cellRenderer: BtnCellRenderer,
				cellRendererParams: {
					clicked: function (_field: any, _act: any) {
						// do something
					}
				}
			}];
		this.frameworkComponents = {
			btnCellRenderer: BtnCellRenderer
		};
		this.defaultColDef = {
			floatingFilter: true
		};
		this.icons = {
			sortUnSort: '<i class="fa fa-sort" style="font-weight:bold;color:black;"/>',
		};
	}
	sizeToFit() { this.gridApi?.sizeColumnsToFit(); }
	loadData() {
		this.ngxUiLoaderService.start("loader-01");
		//API Integration
		this.rowData = [];
		this.OPService.getDetails().subscribe(result => {
			console.info("calling getdetails")
			if (result?.length > 0) {
				this.rowData = result;
				this.rowCount = this.rowData.length;
				if (this.rowData.length) {
					this.totalRecords = this.rowData.length;
					this.paginationPageSize = this.rpPage !== 'ALL' ? this.paginationPageSize : this.totalRecords;
					this.tPage = this.rpPage !== 'ALL' ? Math.ceil(this.totalRecords / this.rpPage) : 1;
					this.sRecord = 1
					this.eRecord = this.rpPage > this.totalRecords ? this.totalRecords : this.rpPage
					if (this.cPage > this.tPage) {
						this.cPage = 1;
					}
				}
				localStorage.setItem('OP-data', JSON.stringify(result));
			}
			else {
				setTimeout(() => {
					this.successMessage = '';
					this.errorMessage = '';
				}, 6500);
			}
			this.ngxUiLoaderService.stop("loader-01");
		});
	}
	goToNextPage() { this.gridApi.paginationGoToNextPage(); this.updatePaginationDetails(); }
	goToPreviousPage() { this.gridApi.paginationGoToPreviousPage(); this.updatePaginationDetails(); }
	goToFirstPage() { this.gridApi.paginationGoToFirstPage(); this.updatePaginationDetails(); }
	goToLastPage() { this.gridApi.paginationGoToLastPage(); this.updatePaginationDetails(); }
	onPageSizeChanged(event: any) { this.gridApi.paginationSetPageSize(Number(event.target.value)); this.updatePaginationDetails(); }
	getCurrentPage(): boolean {
		this.currentPageNo = this.agGrid.api?.paginationGetCurrentPage();
		if (this.currentPageNo == 0) { // NOSONAR
			this.currentPageBoolean = true;
		}
		else { this.currentPageBoolean = false; }
		return this.currentPageBoolean;
	}
	isLastPage(): boolean {
		this.totalPage = Number(this.agGrid.api?.paginationGetTotalPages());
		this.currentPageForTotalPage = Number(this.agGrid.api?.paginationGetCurrentPage()) + 1;
		if (this.totalPage == this.currentPageForTotalPage) { // NOSONAR
			this.isLastPageFound = true;
		}
		else {
			this.isLastPageFound = false;
		}
		return this.isLastPageFound;
	}
	rppChanged(event: any) {
		this.cPage = 1;
		this.gridApi?.setGridOption('paginationPageSize', Number(event.target.value));
		this.updatePaginationDetails();
	}
	updatePaginationDetails() {
		if (this.gridApi) {
		this.cPage = this.gridApi.paginationGetCurrentPage() + 1;
		this.tPage = this.gridApi.paginationGetTotalPages();
		this.sRecord = (this.gridApi.paginationGetPageSize() * this.gridApi.paginationGetCurrentPage()) + 1
		this.eRecord = (this.gridApi.paginationGetPageSize() * this.gridApi.paginationGetCurrentPage()) + this.gridApi.paginationGetPageSize()
		this.totalRecords = this.gridApi.paginationGetRowCount();
		this.eRecord = this.totalRecords < this.eRecord ? this.totalRecords : this.eRecord;
		}
	}
	onGridReady(params: any) {
		this.gridApi = params.api;
		this.gridColumnApi = params.columnApi;
		this.gridOptions?.api?.sizeColumnsToFit();
	}
	onGridSizeChanged(params: any) {
		params?.api?.sizeColumnsToFit();
	}
	$timeout() {
		this.gridOptions.core.handleWindowResize();
	};
	deleteOPRow(val) {
		let desc;
		let ID;
		let url;
		this.rowData.filter(x => x.opID == val).forEach(e => { // NOSONAR
			ID = e.opID;
			desc = e.description;
		});
		const dialogRef = this.dialog.open(DeleteCategoryDialogComponent, {
			disableClose: true,
			width: '510px',
			data: { id: ID, desc: desc, page: "OP" }
		});
		dialogRef.afterClosed().subscribe(result => {
			console.info("data to be deleted:", result.data);
			const deletejson = {
				"opID": result.data
			}
			this.deleteRecords(deletejson);
		});
	}
	deleteRecords(dataArr) {
		console.info("the delete array in deleterecords", dataArr);
		this.ngxUiLoaderService.start("loader-01");
		this.OPService.deleteOP(dataArr).subscribe(_result => {
			this.successMessage = 'Deleted Row(s) Successfully!';
			setTimeout(() => {
				this.successMessage = '';
				this.errorMessage = '';
			}, 6500);
			//fetch latest row data after deleting
			this.loadData();
			// }
		});
	}
	editOPRow(val) {
		let desc;
		let ID;
		let url;
		this.rowData.filter(x => x.opID == val).forEach(e => { // NOSONAR
			ID = e.opID;
			desc = e.description;
			url = e.url;
		});
		// AddCategoryDialogComponent
		const dialogRef = this.dialog.open(AddOpDialogComponent, {
			disableClose: true,
			width: '503px',
			data: { performAction: 'EditCell', placeholderdesc: desc, placeholderurl: url, page: 'Operating Procedure' }
		});
		dialogRef.afterClosed().subscribe(result => {
			if (result.event == 'EditCell') { // NOSONAR
				//API Integration
				const dataArr = {
					"opID": ID,
					"description": result.data1,
					"url": result.data2
				}
				this.ngxUiLoaderService.start("loader-01");
				this.OPService.editOP(dataArr).subscribe(_result => {
					this.successMessage = 'Operating Procedure updated successfully!';
					setTimeout(() => {
						this.successMessage = '';
						this.errorMessage = '';
					}, 6500);
					//fetch latest row data after editing
					this.loadData();
					// }
				});
			}
		});
	}
	openDialog(): void {
		console.info("open dialog");
		const dialogRef = this.dialog.open(AddOpDialogComponent, {
			disableClose: true,
			width: '503px',
			data: { performAction: 'AddCell', placeholder: '' }
		});
		dialogRef.afterClosed().subscribe(result => {
			if (result.event == 'AddCell') { // NOSONAR
				console.info("result", result);
				const dataArr = {
					"opID": null,
					"description": result.data1,
					"url": result.data2
				}
				this.OPService.addOP(dataArr).subscribe(result => {
					if (!result) {
						this.loadData();
						this.errorMessage = 'Operating Procedure already exists!';
						setTimeout(() => {
							this.successMessage = '';
							this.errorMessage = '';
						}, 5000);
					}
					else if (result) {
						this.loadData();
						this.successMessage = 'Operating Procedure added successfully!';
						setTimeout(() => {
							this.successMessage = '';
							this.errorMessage = '';
						}, 5000);
					}
				});
			}
		});
	}
	ngOnInit(): void {
		this.ngxUiLoaderService.start("loader-01");
		// clear contingency data
		sessionStorage.removeItem('contData');
		this.boardService.deleteContingenyList().subscribe(_result => {
			// contingency list deleted
		});
		this.loadData();
	}
	refreshData() {
		this.loadData();
	}
	onFilterChanged(params: FilterChangedEvent) {
		this.rowCount = params.api.getDisplayedRowCount();
	}
}